import React from "react";

export const ErrorIcon = () => (
  <svg width="46" height="45" viewBox="0 0 46 45" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="23.0004" cy="22.043" r="20" transform="rotate(6.2 23.0004 22.043)" fill="#FF5D5D"/>
    <rect x="19.6191" y="16.1428" width="14.85" height="2.12143" rx="1.06071" transform="rotate(51.2 19.6191 16.1428)" fill="white"/>
    <rect x="29.8955" y="18.7691" width="14.85" height="2.12143" rx="1.06071" transform="rotate(141.2 29.8955 18.7691)" fill="white"/>
  </svg>
)
